export default "mutation SubmitReclamation($reclamationId:String!){submitReclamationRequest(reclamationId:$reclamationId)}"